module.exports = new __parcel__URL__("global-table-skeleton-with-projects.tpl.5a5d24b9.svg").toString();